import React from 'react';
import { PlaceholderWrapper, PlaceholderContent, PlaceholderImage } from './styled';
import { SearchViewMode } from 'components/list-view-switcher/constants';

export const ROOT_CLASS_NAME = 'listing-card-placeholder';

const CardPlaceholder: React.FunctionComponent<{ disableAnimation?: boolean; mode?: SearchViewMode; }> = ({ disableAnimation, mode = SearchViewMode.Grid }) => (
  <PlaceholderWrapper
    disableAnimation={disableAnimation}
    className={ROOT_CLASS_NAME}
    mode={mode}
  >
    <PlaceholderImage mode={mode} />
    <PlaceholderContent mode={mode}>
      <div />
      <div />
      <div />
      <div />
    </PlaceholderContent>
  </PlaceholderWrapper>
);

export default CardPlaceholder;
